import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../../style'

// const SCREEN_WIDTH = window.innerWidth
// const SCREEN_HEIGHT = window.innerHeight
const BORDER_RADIUS = 5

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: ${({ height }) => ((typeof height === 'string') ? height : `${height}px`)};
  width: ${({ width }) => ((typeof width === 'string') ? width : `${width}px`)};
  background-image: ${({ background }) => `url('${background}')`};
  background-size: cover;
  background-position-x: center;
  background-color: ${({ bgColor }) => theme[bgColor]};
  border: ${({ border }) => (border ? `1px solid ${theme.red}` : null)};
  border-radius: ${({ rounded }) => (rounded ? `${BORDER_RADIUS}px` : 0)};
  align-items: ${({ alignItems }) => alignItems};
  justify-content: ${({ justifyContent }) => justifyContent};
`

const ImageBackground = ({
    imageUrl,
    imageName,
    width,
    height,
    bgColor,
    justifyContent,
    alignItems,
    children,
    cover,
    fullWidth,
    rounded,
    border,
    style,
}) => {

    // It accepts an external url or an imageName to retrieve it from public assets folder
    const background = imageUrl || `/assets/${imageName}`

    return (
        <Container
            rounded={rounded}
            border={border}
            background={background}
            bgColor={bgColor}
            height={cover ? '100vh' : height}
            width={cover || fullWidth ? '100%' : width}
            alignItems={alignItems}
            justifyContent={justifyContent}
            style={style}
        >
            {children}
        </Container>
    )
}

ImageBackground.propTypes = {
    imageUrl: PropTypes.string,
    imageName: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    bgColor: PropTypes.oneOf(Object.keys(theme)),
    justifyContent: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'space-between',
        'space-around',
        'space-evenly',
    ]),
    alignItems: PropTypes.oneOf([
        'center',
        'flex-start',
        'flex-end',
        'stretch',
    ]),
    children: PropTypes.node,
    cover: PropTypes.bool,
    fullWidth: PropTypes.bool,
    rounded: PropTypes.bool,
    border: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    style: PropTypes.object,
}

ImageBackground.defaultProps = {
    imageUrl: '',
    imageName: 'splitFlapDigit@2x',
    width: 50,
    height: 50,
    bgColor: 'transparent',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    children: null,
    cover: false,
    fullWidth: false,
    rounded: false,
    border: false,
    style: {},
}

export default ImageBackground
